import { get, post } from './api'
import type { BuddyKey, KitchenSummary } from '../../shared/kitchen'

export interface BuddyChoice { buddy: BuddyKey; name: string | null }

export const kitchen = () => get<{ summary: KitchenSummary; buddy: BuddyChoice | null }>('/api/kitchen')
export const chooseBuddy = (buddy: BuddyKey, name?: string) =>
  post<{ buddy: BuddyChoice }>('/api/kitchen/buddy', { buddy, name })
